var _require = require('../errors'),
    JWKKeySupport = _require.JWKKeySupport,
    JOSENotSupported = _require.JOSENotSupported;

var _require2 = require('../help/consts'),
    KEY_MANAGEMENT_ENCRYPT = _require2.KEY_MANAGEMENT_ENCRYPT,
    KEY_MANAGEMENT_DECRYPT = _require2.KEY_MANAGEMENT_DECRYPT;

var _require3 = require('../registry'),
    JWA = _require3.JWA,
    JWK = _require3.JWK; // sign, verify


require('./hmac')(JWA, JWK);

require('./ecdsa')(JWA, JWK);

require('./eddsa')(JWA, JWK);

require('./rsassa_pss')(JWA, JWK);

require('./rsassa')(JWA, JWK);

require('./none')(JWA); // encrypt, decrypt


require('./aes_cbc_hmac_sha2')(JWA, JWK);

require('./aes_gcm')(JWA, JWK); // wrapKey, unwrapKey


require('./rsaes')(JWA, JWK);

require('./aes_kw')(JWA, JWK);

require('./aes_gcm_kw')(JWA, JWK); // deriveKey


require('./pbes2')(JWA, JWK);

require('./ecdh/dir')(JWA, JWK);

require('./ecdh/kw')(JWA, JWK);

var check = function check(key, op, alg) {
  var cache = "_".concat(op, "_").concat(alg);
  var label;
  var keyOp;

  if (op === 'keyManagementEncrypt') {
    label = 'key management (encryption)';
    keyOp = KEY_MANAGEMENT_ENCRYPT;
  } else if (op === 'keyManagementDecrypt') {
    label = 'key management (decryption)';
    keyOp = KEY_MANAGEMENT_DECRYPT;
  }

  if (cache in key) {
    if (key[cache]) {
      return;
    }

    throw new JWKKeySupport("the key does not support ".concat(alg, " ").concat(label || op, " algorithm"));
  }

  var value = true;

  if (!JWA[op].has(alg)) {
    throw new JOSENotSupported("unsupported ".concat(label || op, " alg: ").concat(alg));
  } else if (!key.algorithms(keyOp).has(alg)) {
    value = false;
  }

  Object.defineProperty(key, cache, {
    value: value,
    enumerable: false
  });

  if (!value) {
    return check(key, op, alg);
  }
};

module.exports = {
  check: check,
  sign: function sign(alg, key, payload) {
    check(key, 'sign', alg);
    return JWA.sign.get(alg)(key, payload);
  },
  verify: function verify(alg, key, payload, signature) {
    check(key, 'verify', alg);
    return JWA.verify.get(alg)(key, payload, signature);
  },
  keyManagementEncrypt: function keyManagementEncrypt(alg, key, payload, opts) {
    check(key, 'keyManagementEncrypt', alg);
    return JWA.keyManagementEncrypt.get(alg)(key, payload, opts);
  },
  keyManagementDecrypt: function keyManagementDecrypt(alg, key, payload, opts) {
    check(key, 'keyManagementDecrypt', alg);
    return JWA.keyManagementDecrypt.get(alg)(key, payload, opts);
  },
  encrypt: function encrypt(alg, key, cleartext, opts) {
    check(key, 'encrypt', alg);
    return JWA.encrypt.get(alg)(key, cleartext, opts);
  },
  decrypt: function decrypt(alg, key, ciphertext, opts) {
    check(key, 'decrypt', alg);
    return JWA.decrypt.get(alg)(key, ciphertext, opts);
  }
};